// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiDiagnosis {
    'cptCode'?: string;
    'jCode'?: string;
    'jCodeDescription'?: string;
    'primaryIcdCode'?: string;
    'primaryIcdDescription'?: string;
    'secondaryIcdCode'?: string;
    'secondaryIcdDescription'?: string;
    'treatmentDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiDiagnosis>> = [
        {
            "name":     "cptCode",
            "baseName": "cptCode",
            "type":     "string"
        },
        {
            "name":     "jCode",
            "baseName": "jCode",
            "type":     "string"
        },
        {
            "name":     "jCodeDescription",
            "baseName": "jCodeDescription",
            "type":     "string"
        },
        {
            "name":     "primaryIcdCode",
            "baseName": "primaryIcdCode",
            "type":     "string"
        },
        {
            "name":     "primaryIcdDescription",
            "baseName": "primaryIcdDescription",
            "type":     "string"
        },
        {
            "name":     "secondaryIcdCode",
            "baseName": "secondaryIcdCode",
            "type":     "string"
        },
        {
            "name":     "secondaryIcdDescription",
            "baseName": "secondaryIcdDescription",
            "type":     "string"
        },
        {
            "name":     "treatmentDate",
            "baseName": "treatmentDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiDiagnosis.attributeTypeMap;
    }
}
